import { bech32 } from 'bech32'

const addressToHex = (address) => {
  return Buffer.from(bech32.fromWords(bech32.decode(address).words)).toString('hex')
}

export default addressToHex
